import { render, staticRenderFns } from "./iconComment.vue?vue&type=template&id=99cc701e"
import script from "./iconComment.vue?vue&type=script&lang=js"
export * from "./iconComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports